<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea
                                v-model="compliance_name"
                                :rules="[formRules.required]"
                                label="Compliance Name"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox
                                v-model="is_term_separated"
                                color="primary"
                                label="Is Term Separated?">
                            </v-checkbox>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox
                                v-model="is_upload"
                                @update:model-value="changeToFalse"
                                color="primary"
                                label="Is Upload?">
                            </v-checkbox>
                        </v-col>
                        <v-col v-if="is_upload == true" cols="12" md="6">
                            <v-checkbox 
                                v-model="is_tagged_faculty"
                                color="primary"
                                label="Is able to tag facuties?">
                            </v-checkbox>
                        </v-col>
                        <v-col v-if="is_upload == true" cols="12" md="6">
                            <v-checkbox
                                v-model="is_sorted_course"
                                color="primary"
                                label="Sort course for submission?">
                            </v-checkbox>
                        </v-col>
                        <v-col v-if="is_upload == true" cols="12" md="6">
                            <v-checkbox
                                v-model="is_checklist"
                                color="primary"
                                label="Has checklist?">
                            </v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                v-model="status"
                                label="Is Active"
                                color="primary"
                                inset
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            compliance_name: null,
            is_term_separated: null,
            is_upload: null,
            is_tagged_faculty: null,
            is_checklist: null,
            is_sorted_course: null,
            status: null
        }
    },
    methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Compliance'
            this.dialog_sub_title = 'Add new compliance information'
            this.action = 'add'
            
            this.status = true
        },
        initEdit(data){
            this.dialog = true
            this.dialog_title = 'Compliance'
            this.dialog_sub_title = 'Update compliance information'
            this.action = 'edit'

            this.id = data.id
            this.compliance_name = data.compliance_name,
            this.is_term_separated = data.is_term_separated,
            this.is_upload = data.is_upload,
            this.is_tagged_faculty = data.is_tagged_faculty,
            this.is_checklist = data.is_checklist,
            this.is_sorted_course = data.is_sorted_course,
            this.status = data.status
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    compliance_name: this.compliance_name,
                    is_term_separated: this.is_term_separated,
                    is_upload: this.is_upload,
                    is_tagged_faculty: this.is_tagged_faculty,
                    is_checklist: this.is_checklist,
                    is_sorted_course: this.is_sorted_course,
                    status: this.status
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/compliances', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Compliance successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/compliances/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Compliance successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        changeToFalse(){
            if(this.is_upload == false){
                this.is_tagged_faculty = null
                this.is_sorted_course = null
                this.is_checklist = null
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>